import styled, { css } from 'styled-components';

import colors from '../../../styles/colors';

export const IconContainer = styled.span`
  margin-right: 5px;

  path {
    ${props =>
      props.isActive === 'true'
        ? css`
            fill: ${colors.$brandcolor_primary_dark_green_5};
          `
        : css`
            fill: ${colors.$greyscale_dark_grey};
          `}
  }
`;
